import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Amcdashboard.css";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import {
  IconButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Modal,
  Box,
  Autocomplete,
  Grid,
  Stack,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import ExportToExcel from "../../../Componants/Common/ExportToExcel";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import CommonButton from "../../../Componants/Common/Button";
import {
  fetchAMCList,
  getAmcDropdown,
  fetchAMCSummary,
  updateAMC,
  exportAmcsList,
} from "../../../API Service/apiService";
import Loader from "../../../Componants/Common/Loader";
import Paginate from "../../../Componants/Common/Paginate";
import DynamicTabs from "../../../components/DynamicTabs";
import CloseIcon from "@mui/icons-material/Close";
import toast, { Toaster } from "react-hot-toast";
import { Constants } from "../../../constants/Constants";
import { Calendar } from "../../../Componants/Common/Calender";
import { formatDate } from "../../../utils/dateFormatter";
import { getDefaultDateRange, formatDateToDisplay } from "../../../Componants/Common/CommonFunctions";
import { downloadFile } from "../../../utils/downloadHelper";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(60% - 20px)",
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "#EFF3FE",
  boxShadow: 24,
  border: "none !important",
  borderRadius: "10px",
  p: 4,
};

const amcOptions = [
  { label: "Basic AMC", value: "basic" },
  { label: "Premium AMC", value: "premium" },
  { label: "Gold AMC", value: "gold" },
];

const dateTypeOptions = [
  { label: "Start Date", value: "startDate" },
  { label: "End Date", value: "endDate" },
];

const Amcdashboard = () => {
  const { startDate: defaultStart, endDate: defaultEnd, startDateStr, endDateStr } = getDefaultDateRange();
  const [selectedDate, setSelectedDate] = useState(null);
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [dateType, setDateType] = useState("endDate");
  const [checked, setChecked] = useState(false);
  const [AMCList, setAMCList] = useState([]);
  const [searchParams, setSearchParams] = useState({
    customerId: "",
    productId: "",
    startDate: startDateStr,
    endDate: endDateStr,
    type: "endDate",
    amcStatus: "",
    totalCustomer: "",
    totalAmc: "",
    renewalPending: "",
    mtdAmc: "",
    page: 1,
    limit: 10,
  });
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [AMCDropdownList, setAMCDropdownList] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedAMC, setSelectedAMC] = useState(null);
  const [AMCSummary, setAMCSummary] = useState([]);
  const [editFormData, setEditFormData] = useState({
    customerAmcId: "",
    amcId: "",
    productId: "",
    startDate: "",
    endDate: "",
  });

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handlePageChange = async (newPage) => {
    setPage(newPage);
    const updatedParams = {
      ...searchParams,
      page: newPage,
    };
    setSearchParams(updatedParams);
    await getAMCList(updatedParams);
  };

  const handleDateTypeChange = (event) => {
    setDateType(event.target.value);
  };

  const handleStartDateChange = (fieldName, date, formattedDate) => {
    setStartDate(date);
  };

  const handleEndDateChange = (fieldName, date, formattedDate) => {
    setEndDate(date);
  };

  const handleSearch = async () => {
    const updatedParams = {
      ...searchParams,
      type: dateType,
      startDate: startDate ? startDate.toISOString().split("T")[0] : "",
      endDate: endDate ? endDate.toISOString().split("T")[0] : "",
      totalCustomer: "",
      totalAmc: "",
      renewalPending: "",
      mtdAmc: "",
      page: 1,
      limit: 10,
    };

    setSearchParams(updatedParams);
    await getAMCList(updatedParams);
  };

  const getAMCList = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchAMCList(params);
      console.log(response.amcs);
      if (response.status === "error") {
        setAMCList([]);
        setTotalRecords(0);
      } else {
        setAMCList(response.amcs || []);
        setTotalRecords(response.totalRecords || 0);
      }
    } catch (error) {
      console.error(error);
      setAMCList([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = async () => {
    const { startDate: defaultStart, endDate: defaultEnd, startDateStr, endDateStr } = getDefaultDateRange();
    const resetParams = {
      customerId: "",
      productId: "",
      startDate: startDateStr,
      endDate: endDateStr,
      type: "endDate",
      amcStatus: "",
      totalCustomer: "",
      totalAmc: "",
      renewalPending: "",
      mtdAmc: "",
      page: 1,
      limit: 10,
    };

    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setDateType("endDate");
    setSearchParams(resetParams);
    await getAMCList(resetParams);
  };
  
  const handleSummaryClick = (type) => {
    const newParams = {
      ...searchParams,
      totalCustomer: type === "totalCustomer" ? "true" : "",
      totalAmc: type === "totalAmc" ? "true" : "",
      renewalPending: type === "renewalPending" ? "true" : "",
      mtdAmc: type === "mtdAmc" ? "true" : "",
      page: 1,
    };
    setSearchParams(newParams);
    getAMCList(newParams);
  };

  const getActiveTile = () => {
    if (searchParams.totalCustomer === "true") return "totalCustomer";
    if (searchParams.totalAmc === "true") return "totalAmc";
    if (searchParams.renewalPending === "true") return "renewalPending";
    if (searchParams.mtdAmc === "true") return "mtdAmc";
    return null;
  };

  const getAMCDropdown = async () => {
    try {
      const response = await getAmcDropdown();
      console.log("AMC Dropdown Response:", response);
      if (response && response.status === "success") {
        setAMCDropdownList(response.data || response.amcs || []);
      }
    } catch (error) {
      console.error("Error in getAMCDropdown:", error);
    }
  };

  const getAMCSummary = async () => {
    try {
      setLoading(true);
      const response = await fetchAMCSummary();
      if (response.status == "200") {
        console.log(response.data.data);
        setAMCSummary(response.data.data);
      } else {
        console.error("Failed to fetch AMC summary:", response.message);
        setAMCSummary({
          totalAmcs: 0,
          totalAmcCustomers: 0,
          renewedThisMonth: 0,
          pendingRenewalsNextTwoMonths: 0,
        });
      }
    } catch (error) {
      console.error("Error in fetchAMCSummary:", error);
      setAMCSummary({
        totalAmcs: 0,
        totalAmcCustomers: 0,
        renewedThisMonth: 0,
        pendingRenewalsNextTwoMonths: 0,
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAMCList();
    getAMCSummary();
    getAMCDropdown();
  }, []);

  const handleEditClick = (amc) => {
    console.log(amc);
    setSelectedAMC(amc);
    setEditFormData({
      customerAmcId: amc._id,
      amcId: amc.amcDetails._id,
      productId: amc.modelDetails._id,
      startDate: amc.startDate.split("T")[0], // Format date to YYYY-MM-DD
      endDate: amc.endDate.split("T")[0], // Format date to YYYY-MM-DD
    });
    setEditModalOpen(true);
  };

  const handleEditClose = () => {
    setEditModalOpen(false);
    setSelectedAMC(null);
    handleClearForm();
  };

  const handleEditSave = async () => {
    try {
      console.log("editFormData",editFormData);
      const response = await updateAMC(editFormData);
      if (response.status === "success") {
        toast.success(response.message);
        handleClearForm();
        handleEditClose(); // Close the modal after successful update
        getAMCList(); // Refresh the AMC list
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update AMC details");
    }
  };

  const handleExportToExcel = async () => {
    try {
      setLoading(true);
      const response = await exportAmcsList(searchParams);
      if (response && response.status == "success" && response.data.filePath) {
        downloadFile(response.data.filePath);
        toast.success(response.message || "AMC data exported successfully");
      } else {
        toast.error(response?.message || "Failed to export AMC data");
      }
    } catch (error) {
      console.error("Export Error:", error);
      toast.error("An error occurred during export");
    } finally {
      setLoading(false);
    }
  };

  const handleClearForm = () => {
    setEditFormData({
      customerAmcId: "",
      amcId: "",
      productId: "",
      startDate: "",
      endDate: "",
    });
    setSelectedAMC(null); // Reset the selected AMC
  };

  return (
    <>
      <div className="Amcdashboard-container">
        <HeaderNavigation value={"AMC Dashboard"} />
      </div>
      <DynamicTabs />
      <div className="value-container-Amcdashboard">
        <div 
          className={`firstvaluebox-Amcdashboard ${getActiveTile() === "totalCustomer" ? "active-tile" : ""}`}
          onClick={() => handleSummaryClick("totalCustomer")}
          style={{ cursor: "pointer" }}
        >
          <p className="First-Amcdashboard">Total Customer</p>
          <h4 className="Secound-Amcdashboard">

            {AMCSummary?.totalAmcCustomers}
          </h4>
        </div>
        <div 
          className={`firstvaluebox-Amcdashboard ${getActiveTile() === "totalAmc" ? "active-tile" : ""}`}
          onClick={() => handleSummaryClick("totalAmc")}
          style={{ cursor: "pointer" }}
        >
          <p className="First-Amcdashboard">Total AMC</p>
          <h4 className="Secound-Amcdashboard">{AMCSummary.totalAmcs}</h4>
        </div>
        <div 
          className={`firstvaluebox-Amcdashboard ${getActiveTile() === "renewalPending" ? "active-tile" : ""}`}
          onClick={() => handleSummaryClick("renewalPending")}
          style={{ cursor: "pointer" }}
        >
          <p className="First-Amcdashboard">Renewal Pending in 2 months</p>
          <h4 className="Secound-Amcdashboard">
            {AMCSummary.pendingRenewalsNextTwoMonths}
          </h4>
        </div>
        <div 
          className={`firstvaluebox-Amcdashboard ${getActiveTile() === "mtdAmc" ? "active-tile" : ""}`}
          onClick={() => handleSummaryClick("mtdAmc")}
          style={{ cursor: "pointer" }}
        >
          <p className="First-Amcdashboard">MTD AMC</p>
          <h4 className="Secound-Amcdashboard">
            {AMCSummary.renewedThisMonth}
          </h4>
        </div>
      </div>
      <div className="line-Amcdashboard">
        <div className="textinput-Amcdashboard">
          <FormControl variant="standard" sx={{ minWidth: 120 }}>
            <InputLabel>Date Type</InputLabel>
            <Select
              value={dateType}
              onChange={handleDateTypeChange}
              label="Date Type"
            >
              {dateTypeOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="textinput-Amcdashboard">
          <Calendar
            value={startDate}
            handleChange={handleStartDateChange}
            fieldName="startDate"
            label="Start Date"
          />
        </div>
        <div className="textinput-Amcdashboard">
          <Calendar
            value={endDate}
            handleChange={handleEndDateChange}
            fieldName="endDate"
            label="End Date"
          />
        </div>
        <div className="buttons-Amcdashboard">
          <span className="buttons-Amcdashboard-span">
            <CommonButton name={"Search"} handleOnClick={handleSearch} />
          </span>
        </div>
        <span className="buttons-Amcdashboard-span">
          <CommonButton name={"Cancel"} handleOnClick={handleCancel} />
        </span>
        <div className="textinput-Amcdashboard"></div>
        <div className="textinput-Amcdashboard"></div>
      </div>

      <div className="table-Amcdashboard">
        <div className="excelexport-Amcdashboard">
          <span className="buttons-Amcdashboard-span">
            <ExportToExcel
              onClick={handleExportToExcel}
            />
          </span>
        </div>
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: "#fff", whiteSpace: "nowrap" }} align="center">
                  Customer Name
                </TableCell>
                <TableCell sx={{ color: "#fff", whiteSpace: "nowrap" }} align="center">
                  Product
                </TableCell>
                <TableCell sx={{ color: "#fff", whiteSpace: "nowrap" }} align="center">
                Duration in month
                </TableCell>
                <TableCell sx={{ color: "#fff", whiteSpace: "nowrap" }} align="center">
                No Of Services
                </TableCell>
                <TableCell sx={{ color: "#fff", whiteSpace: "nowrap" }} align="center">
                Cost Of Service
                </TableCell>
                <TableCell sx={{ color: "#fff", whiteSpace: "nowrap", minWidth: 150 }} align="center">
                  AMC
                </TableCell>
                <TableCell sx={{ color: "#fff", whiteSpace: "nowrap", minWidth: 120 }} align="center">
                  Start Date
                </TableCell>
                <TableCell sx={{ color: "#fff", whiteSpace: "nowrap", minWidth: 120 }} align="center">
                  End Date
                </TableCell>
                <TableCell sx={{ color: "#fff", whiteSpace: "nowrap" }} align="center">
                  Status
                </TableCell>
                <TableCell sx={{ color: "#fff", whiteSpace: "nowrap" }} align="center">
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {AMCList.length > 0 ? (
                AMCList.map((item) => (
                  <TableRow key={item._id}>
                    <TableCell align="center">
                      {item?.customerDetails?.customerName || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {item?.modelDetails?.modelName || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {item?.amcDetails?.duration || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {item?.amcDetails?.noOfServices || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {item?.amcDetails?.costOfService || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {item?.amcDetails?.name || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {formatDateToDisplay(item?.startDate)}
                    </TableCell>
                    <TableCell align="center">
                      {formatDateToDisplay(item?.endDate)}
                    </TableCell>
                    <TableCell align="center">
                      {item?.amcStatus || "--"}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton onClick={() => handleEditClick(item)}>
                        <img
                          src={editIcon}
                          alt="Edit"
                          height="20px"
                          width="20px"
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No data found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Edit Modal */}
        <Modal
          open={editModalOpen}
          onClose={handleEditClose}
          aria-labelledby="Update-AMC-Details"
        >
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <h4 style={{ margin: 0 }}>Update AMC Details</h4>
              <IconButton
                onClick={handleEditClose}
                sx={{
                  color: "#32499F",
                  "&:hover": {
                    backgroundColor: "rgba(50, 73, 159, 0.1)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Grid container spacing={3} sx={{ mt: 2 }}>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  options={AMCDropdownList}
                  value={
                    AMCDropdownList.find(
                      (item) => item._id === editFormData.amcId
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setEditFormData({
                      ...editFormData,
                      amcId: newValue ? newValue._id : "", // Ensure amcId is updated or cleared
                    });
                  }}
                  getOptionLabel={(option) => option.name || ""} // Avoid undefined errors
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select AMC"
                      variant="standard"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Start Date"
                  type="date"
                  value={editFormData.startDate}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      startDate: e.target.value,
                    })
                  }
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="End Date"
                  type="date"
                  value={editFormData.endDate}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      endDate: e.target.value,
                    })
                  }
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="flex-end"
              sx={{ mt: 4 }}
            >
              <CommonButton
                name={Constants.save}
                handleOnClick={handleEditSave}
              />
              <CommonButton
                name={Constants.cancel}
                handleOnClick={handleClearForm}
              />
            </Stack>
          </Box>
        </Modal>

        <div className="pagination-container">
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
      {loading && <Loader />}
      <Toaster />
    </>
  );
};

export default Amcdashboard;
